<template>
  <div>
    <!--<base-header></base-header>-->
    <div class="container">

      <div class="text-center mt10 mb30">
        <img src="/static/ccall.png" class="logo-ccall" width="200" />
      </div>

      <form @submit.prevent="setPassword">
        <div class="form-header">{{$t('login.header')}}</div>
        <div class="form-group">
          <input type="text" class="form-control text-center" v-model="username" :placeholder="$t('login.account')" :class="{'form-error': errorMessage['username']}" />
          <p v-for="msg in errorMessage['username']" class="text-error">{{msg}}</p>
        </div>
        <div class="form-group">
          <input type="password" class="form-control text-center" v-model="password" :placeholder="$t('login.password')" :class="{'form-error': errorMessage['password']}" />
          <p v-for="msg in errorMessage['password']" class="text-error">{{msg}}</p>
        </div>
        <div class="form-group text-center btn-submit">
          <base-button type="submit" class="btn-block" :disabled="username.length == 0 || password.length == 0 || isDisabled">{{$t('login.login')}}</base-button>
        </div>
        <p class="text-center"><router-link :to="{name: 'ForgotPasswordPage'}">{{$t('login.forgotPassword')}}</router-link></p>
      </form>
      <p class="text-footer">
        {{$t('login.dontHaveAccount')}} <router-link :to="{name: 'RegisterPage'}">{{$t('login.signup')}}</router-link>
      </p>
    </div>
  </div>
</template>

<script>
  import BaseButton from "../components/Button.vue";
  import BaseHeader from "../components/Header.vue";

  export default {
    components: {
      BaseHeader,
      BaseButton,
    },
    name: 'LoginPage',
    data() {
      return {
        username: '',
        password: '',
        errorMessage: [],
        isDisabled: false,
      };
    },
    methods: {
      setPassword() {
        this.errorMessage = [];
        this.isDisabled = true;
        const formData = new FormData();
        formData.append('username', this.username);
        formData.append('password', this.password);
        this.axios.post('/login', formData).then((response) => {
          if ((response.data.status)) {
            localStorage.setItem('token', response.data.data.token);
            localStorage.setItem('url', response.data.data.url);
            this.$router.push({name: 'Account'});
            /*
            top.window.location.href = response.data.data.url;
            localStorage.setItem('token', response.data.data.token);
            setTimeout(() => {
              this.$router.push({name: 'EditPage'});
            }, 100);
            */
          } else {
            this.errorMessage = response.data.data;
          }
          this.isDisabled = false;
        })
      }
    },
    mounted() {
      const token = localStorage.getItem('token');
      if (token) {
        this.$router.push({name: 'Account'});
      }
    }
  };
</script>
<style scoped="">
  .btn-block {
    width: 80% !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/LoginPage.vue